module.exports = __webpack_public_path__ + "static/NHSA-logo-cd08999ece790afc954f3d7729582c94.png";